import { render } from "./AlteriPanel.vue?vue&type=template&id=cd15f9c6&scoped=true&ts=true"
import script from "./AlteriPanel.vue?vue&type=script&lang=ts"
export * from "./AlteriPanel.vue?vue&type=script&lang=ts"

import "./AlteriPanel.vue?vue&type=style&index=0&id=cd15f9c6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd15f9c6"]])

export default __exports__